<template>
	<section class="gaokao-content centerWidth">
		<div class="tb_padding">
			<article>
				<ul class="gkTest-step">
					<li>
						<div class="step-con step-on flex zhong center">
							<div>
								<img src="../../../image/zn_aa.png" />
								<span>基本信息</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
					</li>
					<li>
						<div class="step-con flex zhong center">
							<div>
								<img src="../../../image/zn_b.png" />
								<span>意向选择</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
					</li>
					<li>
						<div class="step-con flex zhong center">
							<div>
								<img src="../../../image/zn_c.png" />
								<span>精确选择</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
					</li>
					<li>
						<div class="step-con flex zhong center">
							<div>
								<img src="../../../image/zn_d.png" />
								<span>生成志愿表</span>
							</div>
						</div>
					</li>
				</ul>
			</article>
			<article class="tba_div">
				<div class="tba_li tba_liB">
					<h6 class="line_h1">基本信息</h6>
					<section class="flex zhong float">
						<div class="tba_dl flex zhong">
							<label>
								<span>*</span>
								学生姓名
							</label>
							<div class="tba_input">
								<el-input v-model="info.Name" placeholder="请输入学生姓名"></el-input>
							</div>
						</div>
						<div class="tba_dl flex zhong">
							<label>
								<span>*</span>
								总分
							</label>
							<div class="tba_input">
								<el-input v-model="info.TotleScore" placeholder="请输入总分"></el-input>
							</div>
						</div>
						<div class="tba_dl flex zhong" style="width: 40%;">
							<label>
								<span>*</span>
								选科科目
							</label>
							<div class="tba_input flex float" style="width: 334px;">
								<div class="tba_select">
									<el-select v-model="info.Subject1" placeholder="请选择">
										<el-option v-for="item in options" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</div>
								<div class="tba_select">
									<el-select v-model="info.Subject2" placeholder="请选择">
										<el-option v-for="item in options" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</div>
								<div class="tba_select">
									<el-select v-model="info.Subject3" placeholder="请选择">
										<el-option v-for="item in options" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</div>
						</div>
						<div class="tba_dl flex zhong float"></div>
					</section>
				</div>
				<div class="tba_li ">
					<h6 class="line_h1">其他选填信息</h6>
					<section>
						<ul>
							<li class="flex zhong float">
								<div class="tba_dl flex zhong">
									<label>准考证号</label>
									<div class="tba_input">
										<el-input v-model="info.Admission" placeholder="请输入准考证号"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>性别</label>
									<div class="tba_input">
										<el-input v-model="info.Gender" placeholder="请输入性别"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>民族</label>
									<div class="tba_input">
										<el-input v-model="info.Nation" placeholder="请输入民族"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>联系方式</label>
									<div class="tba_input">
										<el-input v-model="info.Contact" placeholder="请输入联系方式"></el-input>
									</div>
								</div>
							</li>
							<li class="flex zhong float">
								<div class="tba_dl flex zhong">
									<label>省份</label>
									<div class="tba_input">
										<el-input style="color: #a1a1a1;" disabled="disabled" v-model="info.Province"
											placeholder="请输入省份"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>学校</label>
									<div class="tba_input">
										<el-input v-model="info.School" placeholder="请输入学校"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>入学年份</label>
									<div class="tba_input">
										<el-input v-model="info.Enrollment" placeholder="请输入入学年份"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>年级</label>
									<div class="tba_input">
										<el-input v-model="info.Grade" placeholder="请输入年级"></el-input>
									</div>
								</div>
							</li>
							<li class="flex zhong float">
								<div class="tba_dl flex zhong">
									<label>语种</label>
									<div class="tba_input">
										<el-input v-model="info.Languages" placeholder="请输入语种"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>体重</label>
									<div class="tba_input">
										<el-input v-model="info.Weight" placeholder="请输入体重"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>应往届</label>
									<div class="tba_input">
										<el-input v-model="info.InPast" placeholder="请输入应往届"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>户籍所在地</label>
									<div class="tba_input">
										<el-input v-model="info.Household" placeholder="请输入户籍所在地"></el-input>
									</div>
								</div>
							</li>
							<li class="flex zhong float">
								<div class="tba_dl flex zhong">
									<label>身高</label>
									<div class="tba_input">
										<el-input v-model="info.Height" placeholder="请输入身高"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>政治面貌</label>
									<div class="tba_input">
										<el-input v-model="info.Political" placeholder="请输入政治面貌"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>色盲色弱</label>
									<div class="tba_input">
										<el-input v-model="info.ColorBlindness" placeholder="请输入色盲色弱"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>左眼视力</label>
									<div class="tba_input">
										<el-input v-model="info.LeftEye" placeholder="请输入左眼视力"></el-input>
									</div>
								</div>
							</li>
							<li class="flex zhong float">
								<div class="tba_dl flex zhong">
									<label>右眼视力</label>
									<div class="tba_input">
										<el-input v-model="info.RightEye" placeholder="请输入右眼视力"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>是否为左撇子</label>
									<div class="tba_input">
										<el-input v-model="info.LeftHanded" placeholder="请输入是否为左撇子"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>身份证号</label>
									<div class="tba_input">
										<el-input v-model="info.IDNo" placeholder="请输入身份证号"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong"><label></label></div>
							</li>
						</ul>
					</section>
				</div>
				<div class="tba_li ">
					<h6 class="line_h1">单科分数</h6>
					<section>
						<ul>
							<li class="flex zhong float">
								<div class="tba_dl flex zhong">
									<label>物理</label>
									<div class="tba_input">
										<el-input v-model="info.Physics" placeholder="请输入物理"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>语文</label>
									<div class="tba_input">
										<el-input v-model="info.Chinese" placeholder="请输入语文"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>数学</label>
									<div class="tba_input">
										<el-input v-model="info.Mathematics" placeholder="请输入数学"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>英语</label>
									<div class="tba_input">
										<el-input v-model="info.English" placeholder="请输入英语"></el-input>
									</div>
								</div>
							</li>
							<li class="flex zhong float">
								<div class="tba_dl flex zhong">
									<label>历史</label>
									<div class="tba_input">
										<el-input v-model="info.History" placeholder="请输入历史"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>化学</label>
									<div class="tba_input">
										<el-input v-model="info.Chemistry" placeholder="请输入化学"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>生物</label>
									<div class="tba_input">
										<el-input v-model="info.Biology" placeholder="请输入生物"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>政治</label>
									<div class="tba_input">
										<el-input v-model="info.Politics" placeholder="请输入政治"></el-input>
									</div>
								</div>
							</li>

							<li class="flex zhong float">
								<!-- 22.2.14 -->

								<div class="tba_dl flex zhong">
									<label>地理</label>
									<div class="tba_input">
										<el-input v-model="info.Geography" placeholder="请输入地理"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>技术</label>
									<div class="tba_input">
										<el-input v-model="info.Technology" placeholder="请输入技术"></el-input>
									</div>
								</div>
								<!-- <div class="tba_dl flex zhong">
									<label>其他</label>
									<div class="tba_input">
										<el-input v-model="info.Other" placeholder="请输入其他"></el-input>
									</div>
								</div> -->
								<div class="tba_dl flex zhong">
									<label>理综</label>
									<div class="tba_input">
										<el-input v-model="info.NaturalComprehensive" placeholder="请输入理综"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong">
									<label>文综</label>
									<div class="tba_input">
										<el-input v-model="info.SocialComprehensive" placeholder="请输入文综"></el-input>
									</div>
								</div>
							</li>
							<li>
								<!-- 22.2.14 -->
								<div class="tba_dl flex zhong">
									<label>其他</label>
									<div class="tba_input">
										<el-input v-model="info.Other" placeholder="请输入其他"></el-input>
									</div>
								</div>
								<div class="tba_dl flex zhong"><label></label></div>
								<div class="tba_dl flex zhong"><label></label></div>
								<div class="tba_dl flex zhong"><label></label></div>
							</li>
						</ul>
					</section>
				</div>
			</article>
			<button class="gaokao-btn" @click="SaveSubmit()">下一步</button>
		</div>

		<div class="tb_two" style="display: none;">
			<h6 class="line_h1">我的志愿表</h6>
			<article class="table">
				<hgroup class="flex">
					<p>编号</p>
					<p>学生姓名</p>
					<p>总分</p>
					<p>选考科目</p>
					<p>更新时间</p>
					<p>操作</p>
				</hgroup>
				<ul>
					<li class="flex" v-for="(item, index) in tableList" :key="index">
						<p>{{ index + 1 }}</p>
						<p>{{ item.Name }}</p>
						<p>{{ item.TotleScore }}</p>
						<p>
							{{
                                item.Subject1 == 1
                                    ? '化学'
                                    : item.Subject1 == 2
                                    ? '生物'
                                    : item.Subject1 == 3
                                    ? '政治'
                                    : item.Subject1 == 4
                                    ? '历史'
                                    : item.Subject1 == 5
                                    ? '地理'
                                    : item.Subject1 == 6
                                    ? '技术'
                                    : item.Subject1 == 8
                                    ? '物理'
                                    : item.Subject1 == 9
                                    ? '文综'
                                    : item.Subject1 == 10
                                    ? '理综'
                                    : '其他'
                            }}
							/{{
                                item.Subject2 == 1
                                    ? '化学'
                                    : item.Subject2 == 2
                                    ? '生物'
                                    : item.Subject2 == 3
                                    ? '政治'
                                    : item.Subject2 == 4
                                    ? '历史'
                                    : item.Subject2 == 5
                                    ? '地理'
                                    : item.Subject2 == 6
                                    ? '技术'
                                    : item.Subject2 == 8
                                    ? '物理'
                                    : item.Subject1 == 9
                                    ? '文综'
                                    : item.Subject1 == 10
                                    ? '理综'
                                    : '其他'
                            }}
							/{{
                                item.Subject3 == 1
                                    ? '化学'
                                    : item.Subject3 == 2
                                    ? '生物'
                                    : item.Subject3 == 3
                                    ? '政治'
                                    : item.Subject3 == 4
                                    ? '历史'
                                    : item.Subject3 == 5
                                    ? '地理'
                                    : item.Subject3 == 6
                                    ? '技术'
                                    : item.Subject3 == 8
                                    ? '物理'
                                    : item.Subject1 == 9
                                    ? '文综'
                                    : item.Subject1 == 10
                                    ? '理综'
                                    : '其他'
                            }}
						</p>
						<p>{{ item.CreateTime }}</p>
						<p class="flex zhong center">
							<span v-on:click="GetVolunteerDetail(item.Id)">查看</span>
							<span v-on:click="confirmDelete(item.Id)">删除</span>
						</p>
					</li>
				</ul>
			</article>

			<div class="gaokao-notice" style="display: none;">
				<!-- <p class="gk-notice-tit">考前须知</p> -->
				<ul class="gk-notice-li">
					<li style="white-space: pre-wrap;">{{ Notes }}</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		props: {
			question: {
				type: Array,
				default: () => {
					return [];
				}
			}
		},
		data() {
			return {
				lzValue: '',
				wzValue: '',
				// 01
				options: [{
						value: 7,
						label: '其他'
					},
					{
						value: 8,
						label: '物理'
					},
					{
						value: 1,
						label: '化学'
					},
					{
						value: 2,
						label: '生物'
					},
					{
						value: 3,
						label: '政治'
					},
					{
						value: 4,
						label: '历史'
					},
					{
						value: 5,
						label: '地理'
					},
					{
						value: 6,
						label: '技术'
					},

					{
						value: 9,
						label: '文综'
					},
					{
						value: 10,
						label: '理综'
					}
				],
				tableList: [],
				info: {
					IDNo: '', // 身份证号
					InPast: '', // 应往届
					Admission: '', // 准考证号
					Biology: '', // 生物
					Chemistry: '', // 化学
					Chinese: '', // 语文
					ColorBlindness: '', // 色盲色弱
					Contact: '', // 联系方式
					English: '', // 英语
					Enrollment: '', // 入学年份
					Gender: '', // 性别
					Geography: '', // 地理
					Grade: '', // 年级
					Height: '', // 身高
					History: '', // 历史
					Household: '', // 户籍所在地
					Languages: '', // 语种
					LeftEye: '', // 左眼视力
					LeftHanded: '', // 是否为左撇子
					Other: '', // 其他
					Mathematics: '', // 数学
					Name: '', // 学生名称
					Nation: '', // 民族
					Physics: '', // 物理
					Political: '', // 政治面貌
					Politics: '', // 政治
					Province: '', // 省份
					RightEye: '', // 右眼视力
					School: '', // 学校
					Subject1: 7, // 科目1 1化学 2生物 3政治 4历史 5地理 6技术 7其他
					Subject2: 7, // 科目2  1化学 2生物 3政治 4历史 5地理 6技术 7其他
					Subject3: 7, // 科目3  1化学 2生物 3政治 4历史 5地理 6技术 7其他
					Technology: '', // 技术
					TotleScore: '', // 总分
					Weight: '', // 体重
					SocialComprehensive: '', // 文综
					NaturalComprehensive: '', // 理综
					Id: 0,
					Primarily: 0
				},
				Notes: ''
			};
		},
		mounted() {
			console.log('11111111111111111', this.$parent.key);
			this.GetVolunteer();
			this.GetUserNotes();
			if (this.$parent.firstId > 0) {
				this.GetVolunteerDetail(this.$parent.firstId);
			}
			var user = this.$util.getUser();
			this.info.Province = this.info.Province.length === 0 ? user.Province : this.info.Province;
			console.log(user);
		},
		methods: {
			// 提交数据
			SaveSubmit: function() {
				var that = this;
				var info = that.info;
				if (info.Name.length === 0) {
					that.$message({
						message: '请输入姓名!',
						type: 'error'
					});
					return;
				}
				if (info.TotleScore.length === 0 || parseFloat(info.TotleScore) === 0) {
					that.$message({
						message: '请输入总分!',
						type: 'error'
					});
					return;
				}
				if (info.Subject1 === 0 || info.Subject2 === 0 || info.Subject3 === 0) {
					that.$message({
						message: '请选择科目!',
						type: 'error'
					});
					return;
				}
				info.Primarily = that.$parent.selectType;
				that.$api.HtppRequest(
					'WebsiteSet/SaveVolunteerBase',
					'POST',
					that.info,
					function(res) {
						console.log('获取详情');
						console.log(res);
						if (res.code === 0) {
							that.$parent.setTotalScore(that.info.TotleScore);
							that.$parent.setNext(1, res.data.Id);
							that.info.Id = res.data.Id;
						}
					},
					function(res) {}
				);
			},
			// 获取志愿列表
			GetVolunteer: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetVolunteerBaseList',
					'GET',
					that.info,
					function(res) {
						console.log('获取志愿列表');
						console.log(res);
						if (res.code === 0) {
							that.tableList = res.data;
						}
					},
					function(res) {}
				);
			},
			// 确认是否删除
			confirmDelete(id) {
				this.$confirm('您确认要删除该数据吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.DeleteVolunteer(id);
				});
			},
			// 删除志愿列表
			DeleteVolunteer: function(id) {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/DeleteVolunteerBase?id=' + id,
					'GET',
					that.info,
					function(res) {
						console.log('删除志愿列表');
						console.log(res);
						if (res.code === 0) {
							that.GetVolunteer();
						}
					},
					function(res) {}
				);
			},
			// 获取志愿详情
			GetVolunteerDetail: function(id) {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetVolunteerBase?id=' + id,
					'GET',
					that.info,
					function(res) {
						console.log('获取志愿详情');
						console.log(res);
						if (res.code === 0) {
							var info = res.data;
							that.info = {
								IDNo: info.IDNo, // 身份证号
								InPast: info.InPast, // 应往届
								Admission: info.Admission, // 准考证号
								Biology: info.Biology, // 生物
								Chemistry: info.Chemistry, // 化学
								Chinese: info.Chinese, // 语文
								ColorBlindness: info.ColorBlindness, // 色盲色弱
								Contact: info.Contact, // 联系方式
								English: info.English, // 英语
								Enrollment: info.Enrollment, // 入学年份
								Gender: info.Gender, // 性别
								Geography: info.Geography, // 地理
								Grade: info.Grade, // 年级
								Height: info.Height, // 身高
								History: info.History, // 历史
								Household: info.Household, // 户籍所在地
								Languages: info.Languages, // 语种
								LeftEye: info.LeftEye, // 左眼视力
								LeftHanded: info.LeftHanded, // 是否为左撇子
								Other: info.Other, // 其他
								Mathematics: info.Mathematics, // 数学
								Name: info.Name, // 学生名称
								Nation: info.Nation, // 民族
								Physics: info.Physics, // 物理
								Political: info.Political, // 政治面貌
								Politics: info.Politics, // 政治
								Province: info.Province, // 省份
								RightEye: info.RightEye, // 右眼视力
								School: info.School, // 学校
								Subject1: info.Subject1, // 科目1 1化学 2生物 3政治 4历史 5地理 6技术 7其他
								Subject2: info.Subject2, // 科目2  1化学 2生物 3政治 4历史 5地理 6技术 7其他
								Subject3: info.Subject3, // 科目3  1化学 2生物 3政治 4历史 5地理 6技术 7其他
								Technology: info.Technology, // 技术
								TotleScore: info.TotleScore, // 总分
								Weight: info.Weight, // 体重
								SocialComprehensive: info.SocialComprehensive, // 文综
								NaturalComprehensive: info.NaturalComprehensive, // 理综
								Id: info.Id,
								Primarily: info.Primarily
							};
							that.$parent.selectType = info.Primarily;
							that.$nextTick(() => {
								that.$parent.scrollTop();
							});
						}
					},
					function(res) {}
				);
			},
			// 获取用户须知
			GetUserNotes: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetUserNotes',
					'GET',
					that.info,
					function(res) {
						console.log('获取用户须知');
						console.log(res);
						if (res.code === 0) {
							that.Notes = res.data ? res.data.Content : '';
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>

<style scoped>
	.tb_two {
		margin-top: 30px;
		padding: 40px 20px 50px 20px;
		border-top: solid 1px #eeeeee;
	}

	.tb_padding {
		padding: 20px 20px 0 20px;
	}

	.gkTest-step {
		margin-top: 0;
	}

	.gaokao-content {
		background-color: #fff;
		margin-bottom: 40px;
	}

	/* 001 */
	.gaokao-notice {
		width: 100%;
		padding: 0 40px 40px 40px;
		height: auto;
		overflow: hidden;
		background-color: #eee;
		margin-top: 40px;
	}

	.gk-notice-tit {
		font-size: 17px;
		color: #333;
		padding: 40px 0 20px 0;
	}

	.gk-notice-li {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.gk-notice-li li {
		font-size: 15px;
		color: #333;
		padding-bottom: 15px;
	}

	.gk-notice-li li:last-child {
		padding-bottom: 0px;
	}

	.table p span {
		font-size: 14px;
		color: #333;
		padding-bottom: 8px;
		border-bottom: solid 1px #333;
		line-height: initial;
		margin: 0 10px;
		cursor: pointer;
	}

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
		color: #666666;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */
	/* 001 */

	.tba_li li:nth-child(n + 2) {
		margin-top: 20px;
	}

	.tba_liB .tba_dl:last-child {
		width: 28%;
	}

	.tba_liB .tba_dl {
		width: 20%;
	}

	.tba_li {
		margin-top: 35px;
	}

	.tba_select {
		width: 100px;
	}

	/* tba_select */

	.tba_input {
		width: 190px;
	}

	.tba_dl label span {
		color: #ff0000;
	}

	.tba_dl label {
		font-size: 14px;
		color: #333;
		width: 90px;
		text-align: right;
		margin-right: 10px;
	}

	.tba_dl {
		width: 25%;
	}

	/* tba_dl */

	.line_h1 {
		font-size: 16px;
		color: #333;
		padding-left: 10px;
		position: relative;
		font-weight: normal;
		margin-bottom: 30px;
	}

	.line_h1::after {
		content: '';
		width: 4px;
		height: 16px;
		border-radius: 50px;
		background-color: #444444;
		position: absolute;
		left: 0;
		top: 50%;
		margin-top: -8px;
		z-index: 1;
	}
</style>
